export enum Delay {
	Short = 200,
	Average = 500,
	Long = 800,
}
